// extracted by mini-css-extract-plugin
module.exports = {"MenuGroup--max-height":"bem_a"};